export const CLONE_REDIRECT_MARKER = "clone_redirect=1"

const SAFE_TAB = /^[A-Za-z0-9_-]{1,64}$/

interface MainBotSettingsLinkOptions {
  chatId: number | null
  tab: string | null
}

/**
 * Direct link into the main bot's WebApp. The tab comes from an unsigned start_param, so anything outside a plain
 * slug is dropped. The trailing marker lets the main app tell a failed sign-in apart from a clone launch.
 */
export const buildMainBotSettingsLink = ({ chatId, tab }: MainBotSettingsLinkOptions): string | null => {
  const username = import.meta.env.VITE_BOT_USERNAME as string | undefined
  if (!username) return null

  const segments: string[] = []
  if (chatId !== null) segments.push(`chat_id=${chatId}`)
  if (tab !== null && SAFE_TAB.test(tab)) segments.push(`tab=${tab}`)
  segments.push(CLONE_REDIRECT_MARKER)

  return `https://t.me/${username}/settings?startapp=${segments.join("==")}`
}
